export const contactsData = {
  email: "2401ankitrajpoot@gmail.com",
  phone: "+917752864661",
  address: "Kanpur, Uttar Pradesh India",

  sheetAPI: "",
};
